import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { SiteOverrideClient } from './client.js';

export function useSiteOverrideClient() {
  const httpClient = useHttpClient({ type: 'backoffice' });
  const client = useMemo(
    () => new SiteOverrideClient(httpClient),
    [httpClient]
  );

  return usePanoramaMethodLogger(client);
}
